export const statusNames = {
  allStatuses: "All statuses",
  active: "Active users",
  inactive: "Inactive users"
};
